// import { Component, OnInit, Inject, Renderer2, OnDestroy, HostListener, ViewChild, ElementRef, AfterViewInit, AfterViewChecked, PLATFORM_ID, DOCUMENT } from '@angular/core';
import {
  Component, OnInit, OnDestroy, HostListener, ViewChild, ElementRef,
  AfterViewInit, AfterViewChecked, Renderer2, Inject, PLATFORM_ID, inject
} from '@angular/core';
import { DOCUMENT, isPlatformBrowser, CommonModule } from '@angular/common';
import { FormGroup, FormControl, Validators, FormsModule } from '@angular/forms';
// import { CommonModule, isPlatformBrowser } from '@angular/common';
// import { trigger, state, style, animate, transition } from '@angular/animations';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { NavigationEnd, NavigationStart, Resolve, Router } from '@angular/router';
import { NgbDropdownModule, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { ArticuloService } from '../../services/articulo.service';
import { Sector } from '../../models/sector.model';
import { UserService } from '../../services/user.service';
import { PedidoService } from '../../services/pedido.service';
import { AuthService } from '../../services/auth.service';
import { Subscription } from 'rxjs';
import { Seccion } from '../../models/seccion.model';
import { Usuario } from '../../models/usuario.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ArticuloListaComponent } from "../articulo-lista/articulo-lista.component";
import { ArticuloCestaComponent } from "../articulo-cesta/articulo-cesta.component";
import { StorageService } from '../../services/storage.service';
import { ArtFiltroResp } from '../../models/art-filtro.model';

@Component({
  standalone: true,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger('cestaAddEffect', [
      state('initial', style({
        color: 'black',
        transform: 'scale(1)'
      })),
      state('final', style({
        color: 'green',
        transform: 'scale(1.2)'
      })),
      transition('final=>initial', animate('200ms')),
      transition('initial=>final', animate('300ms'))
    ]),
    trigger('cestaRemEffect', [
      state('initial', style({
        color: 'black',
        transform: 'scale(1)'
      })),
      state('final', style({
        color: 'red',
        transform: 'scale(1.2)'
      })),
      transition('final=>initial', animate('200ms')),
      transition('initial=>final', animate('300ms'))
    ]),
  ],
  imports: [CommonModule, FormsModule, NgbDropdownModule, ArticuloListaComponent, ArticuloCestaComponent]
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked {
  // Getters que leen dinámicamente del environment (que es un Proxy)
  get URL_LINK_LOGO() { return environment.URL_LINK_LOGO; }
  get LOGO() { return environment.LOGO; }
  get CLIENTE() { return environment.CLIENTE; }
  get VER_HOME() { return environment.VER_HOME; }
  get VER_PROD_LOGOUT() { return environment.VER_PROD_LOGOUT; }
  get LOGO_BACKGROUND_COLOR() { return environment.LOGO_BACKGROUND_COLOR; }
  get SECTOR_BACKGROUND_COLOR() { return environment.SECTOR_BACKGROUND_COLOR; }
  get AGRUPACION() { return environment.AGRUPACION; }

  isPopupVisible = false;
  isPopupPhoneVisible = false;
  isCartVisible = false;
  isCartVisibleFav = false;
  popupPosition: { top: string, right?: string, left?: string } = { top: '100px', right: '100px' };;
  popupPositionPhone: { top: string, right?: string, left?: string } = { top: '100px', right: '100px' };;
  // abre oculta menu categorias
  public catIsCollapsed = false;
  public navbarOpen = false;

  form = new FormGroup({
    itpassword: new FormControl('', [Validators.required, Validators.minLength(environment.PWD_MIN_LENGTH)]),
    itemail: new FormControl('', [Validators.required, Validators.email]),
    chkremember: new FormControl(false)
  });
  usuario: string = '';
  usuarios: Usuario[] | null = null;
  isVisible = false;
  subscription: Subscription | null = null;
  browserRefresh = false;
  verHome = false;
  verPortal = false;
  @ViewChild('dropdownMenu') dropdownMenuRef: ElementRef | undefined;
  showModal: boolean = false;
  isMinimized: boolean = false;
  showDropdown: boolean = false;
  showHelpDropdown: boolean = false;
  videoUrl: SafeResourceUrl = '';
  idVideo1: string = environment.AYUDA_VIDEOS?.[0] || '';
  idVideo2: string = environment.AYUDA_VIDEOS?.[1] || '';
  textVideo1: string = 'de ayuda para pedidos';
  textVideo2: string = 'de ayuda para el portal';
  textVideo: string = '';
  pedVideoURL: string = "https://www.youtube.com/embed/" + this.idVideo1; // https://youtu.be/cCLGmzjYp_E
  portalVideoURL: string = "https://www.youtube.com/embed/" + this.idVideo2;
  @ViewChild('sectorNavbar') sectorNavbar!: ElementRef;
  @ViewChild('seccionNavbar') seccionNavbar!: ElementRef;
  @ViewChild('divNavbar') divNavbar!: ElementRef;
  compruebaTamaño: boolean = false;
  rightArrowVisible = true;
  leftArrowVisible = true;
  showArrows = false;
  sectorNav!: HTMLElement;
  seccionNav!: HTMLElement;
  private checkInterval: any;
  constructor(
    // private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    public router: Router,
    private toastr: ToastrService,
    public articuloService: ArticuloService,
    public pedidoService: PedidoService,
    public authService: AuthService,
    public userService: UserService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private storageService: StorageService,
  ) {
    this.verHome = environment.VER_HOME;
    this.verPortal = environment.VER_PORTAL;
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleOutsideClickPhone = this.handleOutsideClickPhone.bind(this);
    // this.subscription = router.events.subscribe((event) => {
    //   if (event instanceof NavigationStart) {
    //     this.browserRefresh = !router.navigated;
    //   }
    //   if (event instanceof NavigationEnd) {
    //     // this.browserRefresh = !router.navigated;
    //     // console.log('browser refresh=', this.browserRefresh, 'prev URL:', event.url);
    //     // if (this.browserRefresh && event.url !== '/') {
    //     //   this.router.navigate(['']).then();
    //     // }
    //   }
    // });
  }
  readonly renderer = inject(Renderer2);
  ngOnDestroy() {
    if (this.subscription != null)
      this.subscription.unsubscribe();
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
  }

  ngAfterViewInit(): void {
    this.checkVisibility();
    this.checkInterval = setInterval(() => this.checkVisibility(), 100);
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', () => this.checkVisibility());
    }

    this.sectorNav = this.sectorNavbar?.nativeElement;
    this.seccionNav = this.seccionNavbar?.nativeElement;

    if (this.sectorNav) {
      this.sectorNav.addEventListener('scroll', () => this.checkVisibility());
    }
    if (this.seccionNav) {
      this.seccionNav.addEventListener('scroll', () => this.checkVisibility());
    }

  }


  ngOnInit(): void {
    // Verificar si estamos en el navegador
    if (isPlatformBrowser(this.platformId)) {
      // Código jQuery solo se ejecutará en el navegador
      $('.loader').fadeOut();
      $('#preloder').delay(200).fadeOut('slow');

      // Acceso a localStorage solo en el navegador
      this.usuario = this.storageService.getItem('usuario') != null ? this.storageService.getItem('usuario')! : '';

      if (this.usuario !== null && this.storageService.getItem('recordar')) {
        this.f.itemail.setValue(this.usuario);
        this.f.chkremember.setValue(true);
      }
    }

    this.articuloService.getAllSectores().subscribe((sector) => {
      this.RightVisible();
    });
    this.articuloService.getArtFiltros().subscribe({
      next: (res) => {
        this.articuloService.artFiltroResp = res;

        if (res.items.length > 0) {
          res.items[0].art_filtro.forEach(item => {
            if (item.tipo === 'RADIO') {
              item.valor_filtro = item.valores[0]?.codigo ?? '';
            }
          });
        }
      }
    });;
    this.storageService.getItem('ACCESS_TOKEN');
    const initialPath = typeof window !== 'undefined' ? window.location.pathname : '';
    const isPublicPaymentRoute = initialPath.includes('/pagoOnline') || initialPath.includes('/payment-result');
    this.pedidoService.inicializaParametrosUsu(!isPublicPaymentRoute);
    if (!isPublicPaymentRoute) {
      this.pedidoService.getPedido().subscribe({
        next: () => {
          this.router.navigate(['/tienda']).then(() => this.articuloService.getArticulos());
        },
        error: err => {
          console.error('Error al obtener pedido:', err);
        }
      });
    }
  }
  getToken() {
    return this.storageService.getItem('ACCESS_TOKEN');
  }
  openCestaModal(content: any) {
    const modalRef: NgbModalRef = this.modalService.open(content, { scrollable: true });
    modalRef.result.then(
      (result) => {
        console.log(`Closed with: ${result}`);
      },
    );
  }
  isSticky: boolean = false;
  @HostListener('window:scroll')
  checkScroll() {

    const scrollPosition = document.documentElement.scrollTop || 0;
    this.isSticky = scrollPosition > 0;
    /** update 22-01-2021 CJM */
    if (scrollPosition > 300 && window.innerWidth <= 479) {
      $('#section-search').addClass('search-fixed');
    }
    else {
      $('#section-search').removeClass('search-fixed');

    }

    if (scrollPosition > 500 && window.innerWidth >= 479) {

      $('.hero__search').addClass('menu-buscar-estatico');
      $('.product.spad').addClass('menu-estatico');
    }
    else {
      $('.hero__search').removeClass('menu-buscar-estatico');
      $('.product.spad').removeClass('menu-estatico');
    }
    // Las flechas de sectores son elementos flex en línea — no requieren reposicionamiento al hacer scroll

  }
  openCambioPrecio() {
    this.isVisible = true;
  }

  get f() {
    return this.form.controls;
  }

  consultarPedidos() {

  }


  VisibleCart() {
    this.isCartVisible = true;
  }
  cierraMenu() {
    this.isCartVisible = false;
  }
  VisibleCartFav() {
    this.isCartVisibleFav = true;
  }
  cierraMenuFav() {
    this.isCartVisibleFav = false;
  }
  submitLoginForm() {
    // console.log(this.form.value);
    if (this.userService.usuarioBloqueo !== undefined && this.userService.usuarioBloqueo.usu_estado === 'D') {
      if (this.userService.usuarioBloqueo.usuario === this.form.value.itemail
        && this.userService.usuarioBloqueo.clave === this.form.value.itpassword) {
        // abrir ventana
      }
    }
    if (this.form.value.itemail != null && this.form.value.itpassword != null && this.form.value.chkremember != null)
      this.userService.login('', this.form.value.itemail!, this.form.value.itpassword!, this.form.value.chkremember!);
    this.f.itpassword.setValue('');
  }

  headerLogout() {
    this.userService.logout();
    window.location.href = environment.URL_LOGOUT;
  }

  toggleNavbar() {
    if (!this.navbarOpen) {
      $('#mainMenu .humberger__menu__wrapper').addClass('show__humberger__menu__wrapper');
      $('#mainMenu .humberger__menu__overlay').addClass('active');
      $('body').addClass('over_hid');
      // this.renderer.addClass(this.document.body, 'over_hid');
    } else {
      $('#mainMenu .humberger__menu__wrapper').removeClass('show__humberger__menu__wrapper');
      $('#mainMenu .humberger__menu__overlay').removeClass('active');
      $('body').removeClass('over_hid');
    }

    this.navbarOpen = !this.navbarOpen;
  }

  navegaCompra() {
    this.router.navigateByUrl('/compra');
  }
  navegaTienda() {
    if (this.pedidoService.pedido) {
      this.pedidoService.getPedido().subscribe({
        next: res => {
          console.log('Pedido recibido:', res);
          this.router.navigate(['/tienda']).then(() => this.articuloService.getArticulos());
        },
        error: err => {
          console.error('Error al obtener pedido:', err);
        }
      });
    } else {
      this.router.navigate(['/tienda']).then();
    }
  }
  navegaLogin() {
    this.router.navigate(['/login']).then();
  }
  navegaInicio() {
    this.router.navigate(['/']).then();
  }
  navegaPortal() {
    this.router.navigate(['/portal']).then();
  }

  onKeyPressSearch(event: any) {
    if (event.charCode === 13) {
      this.onSearch();
    }
  }
  onClear() {
    this.articuloService.parametros.busca = '';
    this.articuloService.parametros.fam_id = '';
    this.articuloService.parametros.sec_id = '';
    this.articuloService.parametros.sector_id = '';
    this.articuloService.seccionActivo = undefined;
    this.articuloService.sectorActivo = undefined;
    this.articuloService.familiaActivo = undefined;
    this.articuloService.consultaArticulos();
  }
  onClearFilters() {
    this.articuloService.reseteaParametros();
    this.articuloService.consultaArticulos();
  }
  onSearch() {
    this.articuloService.consultaArticulos();
    if (this.router.url !== '/tienda') {
      this.router.navigate(['tienda']).then();
    }
  }

  filtraSector(sector: Sector) {
    if (this.articuloService.sectorActivo === undefined || this.articuloService.sectorActivo.sector_id !== sector.sector_id) {
      this.articuloService.sectorActivo = sector;
    } else {
      this.articuloService.sectorActivo = undefined;
      this.articuloService.seccionActivo = undefined;
    }
    if (this.router.url !== '/tienda') {
      this.router.navigate(['tienda']).then();
    }
  }
  redirectTienda() {
    if (this.router.url !== '/tienda') {
      this.router.navigate(['tienda']).then();
    }
  }
  filtraSeccion(seccion: Seccion) {
    if (this.articuloService.seccionActivo === undefined || this.articuloService.seccionActivo.sec_id !== seccion.sec_id) {
      this.articuloService.seccionActivo = seccion;
    } else {
      this.articuloService.seccionActivo = undefined;
      this.articuloService.familiaActivo = undefined;
    }
    if (this.router.url !== '/tienda') {
      this.router.navigate(['tienda']).then();
    }
  }

  onCambiaClave() {
    this.userService.loginCambiarClave = true;
    if (this.router.url !== '/CambioClave') {
      this.router.navigate(['CambioClave']).then();
    }
  }

  scrollDistance = 300;



  ngAfterViewChecked(): void {
    // setTimeout(() => {
    //   this.RightVisible();
    //   this.LeftVisible();
    // });

  }

  scrollNavBar(direction: 'left' | 'right'): void {
    const navbarSeccion = this.seccionNavbar?.nativeElement;
    const navbarSector = this.sectorNavbar?.nativeElement;

    if (navbarSeccion) {
      const scrollAmount = direction === 'left' ? -this.scrollDistance : this.scrollDistance;
      navbarSeccion.scrollBy({ left: scrollAmount, behavior: 'smooth' });

      // Verificar la visibilidad de las flechas después de mover el navbar
      setTimeout(() => {
        this.LeftVisible();
        this.RightVisible();
      }, 300);
    }
    if (navbarSector) {
      const scrollAmount = direction === 'left' ? -this.scrollDistance : this.scrollDistance;
      navbarSector.scrollBy({ left: scrollAmount, behavior: 'smooth' });

      // Verificar la visibilidad de las flechas después de mover el navbar

      setTimeout(() => {
        this.LeftVisible();
        this.RightVisible();
      }, 300);
    }

  }

  public checkVisibility() {
    const activeNav: HTMLElement | undefined =
      this.sectorNavbar?.nativeElement ?? this.seccionNavbar?.nativeElement;
    
    if (activeNav) {
      this.showArrows = activeNav.scrollWidth > activeNav.clientWidth;
    } else {
      this.showArrows = false;
    }

    this.LeftVisible();
    this.RightVisible();
  }

  private RightVisible(): void {
    const activeNav: HTMLElement | undefined =
      this.sectorNavbar?.nativeElement ?? this.seccionNavbar?.nativeElement;
    
    if (activeNav) {
      // Usar Math.ceil para evitar problemas de subpíxeles
      this.rightArrowVisible =
        Math.ceil(activeNav.scrollLeft) < (activeNav.scrollWidth - activeNav.clientWidth);
    } else {
      this.rightArrowVisible = false;
    }
  }

  private LeftVisible(): void {
    const activeNav: HTMLElement | undefined =
      this.sectorNavbar?.nativeElement ?? this.seccionNavbar?.nativeElement;
    
    if (activeNav) {
      // Solo mostrar la flecha izquierda si hemos scrolleado
      this.leftArrowVisible = activeNav.scrollLeft > 0;
    } else {
      this.leftArrowVisible = false;
    }
  }

  //Logica para el popup de la info del usuario
  togglePopup() {
    this.isPopupVisible = !this.isPopupVisible;
    this.authService.usuarios = this.storageService.getItem("usuarios_model") != null ? JSON.parse(this.storageService.getItem("usuarios_model")!) : null;
    if (this.isPopupVisible) {
      this.popupPosition = { top: '100px', right: '100px' }; // posición popup
      document.addEventListener('click', this.handleOutsideClick.bind(this));
      setTimeout(() => {
        document.addEventListener('click', this.handleOutsideClick);
      });
    } else {
      this.hidePopup();
    }

  }
  togglePopupPhone() {
    this.isPopupPhoneVisible = !this.isPopupPhoneVisible;

    if (this.isPopupPhoneVisible) {
      this.popupPositionPhone = { top: '30%', left: '10%' }; // posición popup
      setTimeout(() => {
        document.addEventListener('click', this.handleOutsideClickPhone);
      });
    } else {
      this.hidePopupPhone();
    }

  }
  handleOutsideClick(event: MouseEvent) {
    const popupElement = document.querySelector('.popup-menu');
    const triggerElement = document.querySelector('.header__top__info__user');

    if (
      popupElement &&
      !popupElement.contains(event.target as Node) &&
      triggerElement &&
      !triggerElement.contains(event.target as Node)
    ) {
      this.hidePopup();
    }
  }
  handleOutsideClickPhone(event: MouseEvent) {
    const popupElement = document.querySelector('.popup-menu-phone');
    const triggerElement = document.querySelector('.header__top__info__user__phone');

    if (
      popupElement &&
      !popupElement.contains(event.target as Node) &&
      triggerElement &&
      !triggerElement.contains(event.target as Node)
    ) {
      this.hidePopupPhone();
    }
  }
  hidePopup() {
    this.isPopupVisible = false;
    document.removeEventListener('click', this.handleOutsideClick);
  }

  hidePopupPhone() {
    this.isPopupPhoneVisible = false;
    document.removeEventListener('click', this.handleOutsideClickPhone);
  }

  onAccept() {
    if (this.userService.usrSelect >= 0) {
      this.userService.userAsign(this.userService.usrSelect);
    }
    this.isPopupVisible = false;
    document.removeEventListener('click', this.handleOutsideClick.bind(this));
    location.reload();
  }
  onAcceptPhone() {
    if (this.userService.usrSelect >= 0) {
      this.userService.userAsign(this.userService.usrSelect);
    }
    this.isPopupPhoneVisible = false;
    document.removeEventListener('click', this.handleOutsideClickPhone.bind(this));
    location.reload();
  }

  refresh(): void {
    window.location.reload();
  }

  verTutorial(type: string): void {
    if (type === 'ped') {
      this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.pedVideoURL);
      this.textVideo = this.textVideo1;
    } else if (type === 'port') {
      this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.portalVideoURL);
      this.textVideo = this.textVideo2;
    }

    this.showModal = true;


  }

  minimizeModal() {
    console.log("Minimizar modal");
    this.isMinimized = !this.isMinimized;
    // Agrega aquí la lógica para minimizar el modal, como cambiar su tamaño o posición
  }
  restoreModal() {
    this.isMinimized = false;
  }
  // Método para cerrar el modal
  closeModal(): void {
    this.showModal = false;
    this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl('about:blank'); // Limpiar el video para detener la reproducción
  }
  toggleDropdown(): void {
    this.showDropdown = !this.showDropdown;  // Cambia el estado de visibilidad
  }

  toggleHelpDropdown() {
    this.showHelpDropdown = !this.showHelpDropdown; // Cambia el estado de la ayuda
    // Asegúrate de que al abrir el dropdown de ayuda, se mantenga abierto
    this.showDropdown = true;  // Mantener el menú principal abierto
  }
  closeDropdown() {
    this.showDropdown = false;  // Cierra el menú principal
    this.showHelpDropdown = false;  // Cierra el dropdown de ayuda
  }
  onOutsideClick(event: any) {
    if (this.dropdownMenuRef != undefined && !this.dropdownMenuRef.nativeElement.contains(event.target)) {
      this.closeDropdown(); // Cierra el menú si se hace clic fuera
    }
  }
  handleMenuClick() {
    this.closeDropdown();
  }
}
